import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const DollarBill = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.25 2H13.75C14.16 2 14.5 1.66 14.5 1.25C14.5 0.84 14.16 0.5 13.75 0.5H2.25C1.84 0.5 1.5 0.84 1.5 1.25C1.5 1.66 1.84 2 2.25 2Z"
          fill="#ADACA8"
        />
        <path
          d="M8.11999 8.75001C7.62999 8.66001 7.36999 8.51001 7.34999 8.29001C7.32999 8.12001 7.37999 8.07001 7.40999 8.04001C7.53999 7.90001 7.84999 7.83001 8.02999 7.83001C8.44875 7.83001 8.57922 8.03877 8.62955 8.1193C8.84955 8.4693 9.30999 8.58001 9.65999 8.36001C10.01 8.14001 10.12 7.68001 9.89999 7.33001C9.62999 6.89001 9.21999 6.59001 8.73999 6.45001C8.70999 6.07001 8.38999 5.76001 7.99999 5.76001C7.60999 5.76001 7.27999 6.07001 7.25999 6.47001C6.90999 6.58001 6.55999 6.76001 6.29999 7.05001C5.95999 7.42001 5.80999 7.91001 5.85999 8.45001C5.90999 9.00001 6.23999 9.96001 7.85999 10.25C8.74095 10.4066 8.75959 10.6399 8.76936 10.7622L8.76999 10.77C8.76999 10.88 8.73999 10.98 8.65999 11.06C8.52999 11.2 8.28999 11.28 8.03999 11.28C7.42999 11.28 7.30999 11.05 7.25999 10.95C7.06999 10.58 6.61999 10.43 6.24999 10.62C5.87999 10.81 5.72999 11.26 5.91999 11.63C6.12999 12.04 6.52999 12.51 7.28999 12.7C7.36999 13.03 7.64999 13.28 8.00999 13.28C8.36999 13.28 8.64999 13.02 8.72999 12.69C9.11999 12.58 9.46999 12.39 9.73999 12.12C10.1 11.75 10.29 11.26 10.28 10.75C10.25 9.70001 9.52999 9.04001 8.12999 8.79001L8.11999 8.75001Z"
          fill="#ADACA8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.75 3.5H13.25C14.77 3.5 16 4.73 16 6.25V12.75C16 14.27 14.77 15.5 13.25 15.5H2.75C1.23 15.5 0 14.27 0 12.75V6.25C0 4.73 1.23 3.5 2.75 3.5ZM4.68 14H11.33C11.63 12.4 12.9 11.14 14.5 10.83V8.18C12.9 7.88 11.64 6.61 11.33 5.01H4.68C4.38 6.61 3.11 7.87 1.51 8.18V10.83C3.11 11.13 4.37 12.4 4.68 14ZM14.5 6.62V6.25C14.5 5.56 13.94 5 13.25 5H12.88C13.12 5.77 13.73 6.37 14.5 6.62ZM3.12 5H2.75C2.06 5 1.5 5.56 1.5 6.25V6.62C2.27 6.38 2.87 5.77 3.12 5ZM1.5 12.38V12.75C1.5 13.44 2.06 14 2.75 14H3.12C2.88 13.23 2.27 12.63 1.5 12.38ZM12.88 14H13.25C13.94 14 14.5 13.44 14.5 12.75V12.38C13.73 12.62 13.13 13.23 12.88 14Z"
          fill="#ADACA8"
        />
      </svg>
    </SvgIcon>
  )
}

export default DollarBill
